import styles from './style.module.scss';
import { Col, Row, Spin, Table, Typography } from 'antd';
import useInvoicesCompareFootfallSales from '../useInvoicesCompareFootfallSales';
import BarChangeChart from '../../../charts/barChange';
import PrintFilterText from '../../printFiiterText';

const Print = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const {
    title,
    data,
    columns,
    format,
    loading,
    summary,
    searchParams,
    filters,
  } = useInvoicesCompareFootfallSales(true, allReportsData, isAllReports);
  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        <Spin spinning={loading}>
          {!allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
              <PrintFilterText
                availableFilters={availableFilters}
                searchParams={searchParams}
              />
            </Row>
          )}
          {allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>Footfall & sales</Typography.Title>
              </Col>
            </Row>
          )}
          <br />
          <Row>
            <Col span={24}>
              <Table
                loading={loading}
                columns={columns}
                dataSource={data.tableData}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 700 }}
                summary={summary}
              />
            </Col>
            <Col span={12} className={'chartColl'}>
              <BarChangeChart
                keys={['Footfall', 'Net Sales']}
                data={data}
                format={format}
                lineItemWidth={150}
                translateX={200}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default Print;
